import styled from 'styled-components/macro'

export const RootS = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
`

interface WrapperInnerPropsI {
  showMinimal: boolean
}

export const WrapperInnerS = styled.div<WrapperInnerPropsI>`
  width: 100%;

  display: flex;
  justify-content: space-between;
  flex-direction: ${({ showMinimal }) => showMinimal ? 'row' : 'column'};
  align-items: center;
  gap: ${({ showMinimal }) => showMinimal ? '5px' : '0'};

  ${({ showMinimal }) => showMinimal && `
    > * {
      flex-grow: 1;
    }
  `}
`

export const EmailLinkS = styled.button`
  width: auto;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  margin: 16px auto 0;
  padding: 0;

  background: transparent;
  border: none;
  outline: none;

  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #4d4e53;
  text-decoration: underline;

  cursor: pointer;
`
